// extracted by mini-css-extract-plugin
module.exports = {"label":"MenuOptionsGroup_label__2lVVn","options":"MenuOptionsGroup_options__kdmx9"};